// Converts ISO date to human readable format
export default function(d){
	let dt = new Date(d);
	let mths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    let day = ((dt.getDate() + 1) < 10 ? '0' : '') + dt.getDate();
    return day + ' ' + mths[dt.getMonth()] + ' ' + dt.getFullYear(); 
}


// WEBPACK FOOTER //
// ./src/components/DateFilter.js